import React from 'react'
import '../walletTabs/WalletTab.css'

const WalletTab = () => {
  return (
    <div className='tabs-detail-sec wallet-tab'>
    <form action="">
        <div className='wallet-box'>
            <h2>Payment</h2>
            <div className='wallet-content-details'>
                <div className='form-group'>
                    <input type="text" className="form-control" id="" placeholder="Apple Pay" />
                </div>
                <div className='form-group'>
                    <input type="text" className="form-control" id="" placeholder="Card" />
                </div>
                <div className='form-group'>
                    <input type="email" className="form-control" id="" placeholder="Google Pay" />
                </div>
                <div className='form-group'>
                    <input type="text" className="form-control" id="" placeholder="PayPal" />
                </div>
            </div>
        </div>
    </form>
</div>
  )
}

export default WalletTab
